import type { NavigateFunction } from 'react-router';

export const navigation: NavigationHolder = {
  navigate: null,
};

type NavigationHolder = {
  navigate: null | NavigateFunction;
};
